/* eslint-disable react/forbid-prop-types */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { postData } from '../../redux/reducers/data';

export default function DeleteTransaction({ transaction, transactions, signalHandleSubmit, setSignalHandleSubmit }) {
  DeleteTransaction.propTypes = {
    transaction: PropTypes.object,
    transactions: PropTypes.arrayOf(PropTypes.object),
    signalHandleSubmit: PropTypes.bool.isRequired,
    setSignalHandleSubmit: PropTypes.func.isRequired,
  };
  DeleteTransaction.defaultProps = {
    transaction: null,
    transactions: [],
  };
  const { t } = useTranslation('accountDetails', { keyPrefix: 'splitMenu' });

  const dispatch = useDispatch();
  const transactionsToDelete = (transactions && transactions.length > 0 ? transactions : transaction ? [transaction] : []);
  const primaryTransaction = transactionsToDelete[0];

  useEffect(() => {
    if (signalHandleSubmit && primaryTransaction && transactionsToDelete.length > 0) {
      dispatch(postData({
        data: transactionsToDelete.map((txn) => ({ ...txn, importFlag: 'delete' })),
        category: primaryTransaction.category,
        accountId: primaryTransaction.accountId,
      }));
      window.dispatchEvent(
        new CustomEvent('setDialog', {}),
      );
    }
  }, [signalHandleSubmit]);

  return (
    <div className="mt-2">
      <p className="text-sm text-gray-500">{t('pressSaveToDelete')}</p>
    </div>
  );
}
